import type { ISerialize } from '@/objects/ISerialize';

export class SignalrResultItemSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrResultItemSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrResultItemSubscribeParameters {
        return new SignalrResultItemSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrResultItemSubscribeParameters {
        return new SignalrResultItemSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrResultItemSubscribeParameters from another instance of SignalrResultItemSubscribeParameters.
     * @param other The SignalrResultItemSubscribeParameters you want to clone
     * @returns A cloned SignalrResultItemSubscribeParameters
     */
    public static FromOther(other: SignalrResultItemSubscribeParameters): SignalrResultItemSubscribeParameters {
        return SignalrResultItemSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrResultItemSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrResultItemSubscribeParameters';
}
